import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

// Home Editorial (anterior portada), conservada como referencia y fuera del índice.
export const Route = createFileRoute("/en/editorial")({
  head: () => {
    const h = publicToolHead("home", "en");
    return {
      ...h,
      meta: [{ title: "Editorial Home | Retail Lemon" }, { name: "robots", content: "noindex, follow" }],
      links: [{ rel: "canonical", href: "https://www.retaillemon.com/en" }],
    };
  },
  component: () => <Index />,
});
